import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export const StudentAvatar = ({ student, className, fallbackClassName }) => {
  const [src, setSrc] = useState(student.photo_url || null);
  useEffect(() => {
    if (student.photo_url) { setSrc(student.photo_url); return undefined; }
    if (!student.face_photo_path) { setSrc(null); return undefined; }
    let url = null; let alive = true;
    api.get(`/students/${student.id}/face-photo`, { responseType: "blob" })
      .then((r) => { url = URL.createObjectURL(r.data); if (alive) setSrc(url); else URL.revokeObjectURL(url); })
      .catch(() => { if (alive) setSrc(null); });
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [student.id, student.photo_url, student.face_photo_path]);
  return (
    <Avatar className={className} data-testid="student-avatar">
      {src && <AvatarImage src={src} alt={student.full_name} data-testid="student-avatar-img" />}
      <AvatarFallback className={fallbackClassName}>{student.full_name.slice(0, 2).toUpperCase()}</AvatarFallback>
    </Avatar>
  );
};
